/*
Aditya  9/21/2022   2700799562   Fixed GAL-190 Global Fieldlist bug
Sohel   10/03/2022  2700768219   Category look up Changes, Fixed GAL-343,336 and Download Configuration Payload Changes
ashraf  10/04/2022  2700799562   fixed usage Api payload for download in usage tab
Sohel   10/06/2022  2700799562   Fixed based on Framework record not sorted issue
Sohel   10/11/2022  2700799562   Download Configuration Usage Payload Changes
Sohel   10/14/2022  2700753823   Added Code Comments Changes
Sohel   10/14/2022  2700753823   Added Code Comments
Suresh  10/17/2022  2700799562   Design Enhancements in global Field Group, List.
saikrishna 11/03/2022 2700799562 changed the paginationOptions
Sohel 11/05/2022 2700799562 rename download configurations
Poornima 12/01/2022 2700799562 Added usage popup
Poornima 12/01/2022 2700799562 Usage component issues fixed
Sohel 12/07/2022 2700799562 Added Download Configuration
akhila 12/13/2022 2700799562 Added repositoryFields column in usage table
Suresh Peddavoora 12/19/2022 2700799562 Fixed Table Column Alignments
kavyareddy12/20/2022 2700799562 Renamed search data repository
Suresh peddavoora  12/29/2022 2700799562 Removed unnecessary code from styles
Ashraf 01/02/2022 2700799562 renamed usage header title
saikrishna 01/04/2023 2700799562  add createdby and created date to payload
La;itha 01/06/2023 2700799562 integated updated Api
Suresh peddavoora  02/02/2023 2700799562 Fixed Description Column data Alignments
// Suresh Peddavoora 02/24/2023 2700799562 New UI changes


Akhila  03/15/2023 2700799562 Rename text in usage popup
Akhila 03/16/2023 2700799562 bug fixed first capital letter
uday 10/03/2023 2700799562  fixed table alignemts issues
Sohel 10/09/2023 2700799562 Added Company and Field Description in Payload
Sohel 12/05/2023 2700799562 download configuration usage printindividual added payload
*/
import React, {useEffect, createRef} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import capitalizeFirstLetter from '../../../../../util/capitalizeFirstLetter';
// import MaterialTable from "material-table";
import {tableIcons} from '../../../../../components/TableIcons';
import {resetUsageData} from '../../../../../redux/reducers/GlobalField/AddFieldList';
import {ErrorSnackbar, SuccessSnackbar} from '../../../../../components/CustomSnackBar';
import PageLoader from '../../../../../components/PageLoader';
import {Button, TablePagination} from '@material-ui/core';
import {postPrintUsage, resetPrintUsageData} from '../../../../../redux/reducers/printUsage';
import {ArrowBack} from '@material-ui/icons';
import {defaultRows} from '../../../../../constants/ReusableTablePagination';
import GuiTable from '../../../../../components/FormComponents/GuiTable';
import {tablePageRows} from '../../../../../constants/ReusableConstants';
import {backButtonText,modulesText} from '../../../../../util/Content';
import moment from 'moment';

export default function UsageFieldList({setTabValue, fieldListRowData, setUsageState}) {
  const tableRef = createRef();
  const companyData = JSON.parse(sessionStorage.getItem('companyName'));
  const printusage = useSelector(({printusage}) => printusage);
  // const { isLoading, successMsg, errorMsg, fieldListDataUsage } = useSelector(
  //   ({ addFieldList }) => addFieldList
  // );
  const {successMsg, errorMsg, isLoading, dataRepoUsage} = useSelector(
    ({dataRepository}) => dataRepository,
  );
  const dispatch = useDispatch();

  // print error or success toast message reset after 3sec.(2700799562)
  useEffect(() => {
    if (printusage.errorMsg || printusage.successMsg) {
      setTimeout(() => {
        dispatch(resetPrintUsageData());
      }, 3000);
    }
  }, [printusage.errorMsg, printusage.successMsg]);
  // reset Usage Data and reset Usage state(2700799562)
  useEffect(() => {
    return () => {
      setUsageState(false);
      dispatch(resetUsageData());
    };
  }, []);

  const object = dataRepoUsage?.placeResponse ? dataRepoUsage?.placeResponse : {};

  const values = [];
  object &&
    Object.entries(object)?.forEach(([key, value]) => {
      value?.length > 0 &&
        value?.forEach((el, i) => {
          values.push({
            frameWork: key,
            codes: el?.code,
            description: el?.description ?? '',
            repositoryFields: el?.repositoryFields ?? '',
          });
        });
    });

  const columns = [
    {
      title: modulesText,
      field: 'frameWork',
      cellStyle: {
        maxWidth: 100,
        minWidth: 100,
      },
      render: (rowData) => {
        return rowData?.frameWork ? capitalizeFirstLetter(rowData?.frameWork) : ' ';
      },
    },
    {
      title: 'Name',
      field: 'codes',
      cellStyle: {
        maxWidth: 100,
        minWidth: 100,
      },
      customFilterAndSearch: (term, rowData) => rowData?.codes?.toString()?.indexOf(term) > -1,
      render: (rowData) => {
        return rowData?.codes ? rowData?.codes : ' ';
      },
    },
    {
      title: 'Description',
      field: 'description',
      cellStyle: {
        maxWidth: 250,
        minWidth: 250,
      },
      render: (rowData) => (
        <>
          <div
            style={{
              maxWidth: 300,
              textAlign: 'justify',
              whiteSpace: 'normal',
              wordWrap: 'break-word',
            }}
          >
            {rowData?.description ? rowData?.description : ' '}
          </div>
        </>
      ),
    },
    {
      title: 'Repository Fields',
      field: 'repositoryFields',
      cellStyle: {
        maxWidth: 450,
        minWidth: 450,
      },
      render: (rowData) => (
        <>
          <div
            style={{
              maxWidth: 500,
              whiteSpace: 'normal',
              wordWrap: 'break-word',
            }}
          >
            {rowData?.repositoryFields ? rowData?.repositoryFields : ' '}
          </div>
        </>
      ),
    },
  ];
  return (
    // Added Search field List Button for Routing (2700799562)
    <div className={`mb-0`}>
      <div className="button-table-spacing-mb justify-content-start new-standard-textfields">
        <Button
          variant="outlined"
          type="button"
          className={`search-btn mx-1`}
          onClick={() => {
            setTabValue(0);
          }}
        >
          <ArrowBack className="mr-2" />
          {backButtonText}
        </Button>
      </div>
      <div className="custom-table custom-toolbar-icons global-field-table new-standard-textfields tablescroll-block">
        <GuiTable
          title={`${fieldListRowData?.repositoryName} - ${fieldListRowData?.repositoryDescription} Data Repository has been used in the following places.`}
          columns={columns}
          icons={tableIcons}
          data={values}
          tableRef={tableRef}
          // onSearchChange={() => {
          //   setSearch(tableRef?.current?.dataManager?.searchText);
          // }}
          textAlign="left"
          actions={[]}
          components={{
            Pagination: (props) => (
              // Added Download Configuration Buttons in Table pagination (2700799562)
              <div className="global-field-table-footer ">
                <div className="mt-2">
                  <Button
                    type="button"
                    variant="outlined"
                    className={`mx-1 search-btn`}
                    disabled={dataRepoUsage.userMetrix === 'No'}
                    onClick={(event) => {
                      dispatch(
                        postPrintUsage({
                          category: fieldListRowData?.category ? fieldListRowData?.category : '',
                          createdBy: fieldListRowData?.createdBy?.userName
                            ? fieldListRowData?.createdBy?.userName
                            : '',
                          createdDate: fieldListRowData?.createdDate
                            ? moment(fieldListRowData?.createdDate).format('MM/DD/YYYY')
                            : '',
                          // createdBy:fieldListRowData?.createdBy ? fieldListRowData?.createdBy : "",
                          // createdDate:fieldListRowData?.createdDate ? fieldListRowData?.createdDate : "",
                          fieldListOrderBy: '',
                          fieldListOrderDerection: '',
                          fieldName: '',
                          frameworkUsageOrderBy: '',
                          frameworkUsageOrderDerection: '',
                          repositoryName: fieldListRowData?.repositoryName
                            ? fieldListRowData.repositoryName
                            : '',
                          repositoryDescription: fieldListRowData?.repositoryDescription
                            ? fieldListRowData.repositoryDescription
                            : '',
                          repositoryType: fieldListRowData?.repositoryType
                            ? fieldListRowData?.repositoryType
                            : '',
                          fieldDescription: fieldListRowData?.fieldDescription
                            ? fieldListRowData?.fieldDescription
                            : '',
                          company: companyData?.length > 0 ? companyData : [],
                          sourceType: 'DATA REPOSITORY',
                          printIndividual: 'Y',
                        }),
                      );
                    }}
                  >
                    Download Configuration Usage
                  </Button>
                </div>
                <div>
                  <TablePagination
                    {...props}
                    SelectProps={{
                      inputProps: {'aria-label': 'Rows per screen'},
                    }}
                    labelRowsPerPage={'Rows per screen:'}
                    rowsPerPageOptions={tablePageRows}
                    onChangeRowsPerPage={(event) => {
                      props.onChangeRowsPerPage(event);
                    }}
                  />
                </div>
              </div>
            ),
          }}
          options={{
            paging: true,
            toolbar: true,
            search: false,
            sorting: true,
            emptyRowsWhenPaging: false,
            headerStyle: {
              fontWeight: 'bold',
              fontSize: '0.938rem',
              padding: '16px',
            },
            pageSize: defaultRows,
            pageSizeOptions: tablePageRows,
          }}
        />
      </div>
      {(isLoading || printusage.isLoading) && <PageLoader />}
      {(errorMsg || printusage.errorMsg) && (
        <ErrorSnackbar errorMsg={errorMsg || printusage.errorMsg} />
      )}
      {(successMsg || printusage.successMsg) && (
        <SuccessSnackbar successMsg={successMsg || printusage.successMsg} />
      )}
    </div>
  );
}
